module.exports = __webpack_public_path__ + "static/media/Marvel_Content.c0e2c2b8.PNG";